import { makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  formControl: {
    marginBottom: theme.spacing(3)
  }
}));
